/*
 * @Date: 2020-12-21 09:42:40
 * @Description: main
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import { Spin,Cascader,Modal } from '@babylon/design';

import App from '@/App.vue';
import Icon from '@/components/Icon/index';
import store from '@/store';
import router from '@/router';
import Loading from '@/assets/img/loading.svg';
import i18nMixin from '@/mixins/i18n.mixin';
import './utils/importComponents';
import {  Carousel, CarouselItem, MessageBox } from 'element-ui';

import { Installer } from '@/utils/request';
import PermissionHelper from '@/directives/permission';
import locales, { defaultLang } from '@/locales';

import '@/assets/theme/theme.less';

import '@/utils/filters';
import '@/directives/auth';
import VueMatomo from 'vue-matomo';

// 引入Viewer插件
import VueViewer, { directive as viewerDirective } from 'v-viewer';
// 引入Viewer插件的图片预览器的样式
import 'viewerjs/dist/viewer.css';
// 使用Viewer图片预览器
Vue.use(VueViewer);
// 用于图片预览的指令方式调用 在元素上加上会处理元素下所有的图片,为图片添加点击事件,点击即可预览
Vue.directive('viewer', viewerDirective({
    debug: true
}));
VueViewer.setDefaults({
    // 需要配置的属性 注意属性并没有引号
    title: false,
    // toolbar: true,
    toolbar: {
        zoomIn: 4,
        zoomOut: 4,
        oneToOne: 4,
        reset: true,
        prev:{
            show: false
        },
        play: {
            show: false
        },
        next: {
            show: false
        },
        rotateLeft: 4,
        rotateRight: 4,
        flipHorizontal: 4,
        flipVertical: 4
    },
    rotatable: false,
    navbar:false,
    fullscreen:false,
    scalable:false
});
// styles globally
// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
// import './mock';
const config = {
    // UserID passed to Web Analyzer
    userId: undefined // Default: undefined
};
if(window.analyzerImporter) {
    if(process.env.NODE_ENV === 'int'){
        window.analyzerImporter.getVueMatomo(Vue, VueMatomo, 205, config); // 'config' is an object, it is not mandatory.
    }
    if(process.env.NODE_ENV === 'production'){
        window.analyzerImporter.getVueMatomo(Vue, VueMatomo, 206, config); // 'config' is an object, it is not mandatory.
    }
}

Spin.setDefaultIndicator({
    indicator: (h) => {
        return h('img', { attrs: { src: Loading, alt: 'loading' } });
    }
});
Vue.config.productionTip = false;
Vue.prototype.$confirm = MessageBox.confirm;

// plugins
Vue.use(Icon);
// Vue.use(Viewer);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Installer);
Vue.use(PermissionHelper);

// mixins
Vue.mixin(i18nMixin);
Vue.use(Cascader);
Vue.use(Modal);
store.dispatch('setLang', defaultLang, { root: true });

new Vue({
    router,
    store,
    i18n: locales,
    render: (h) => h(App)
}).$mount('#app');
